import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, hidePreloader, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {hideLoadingPayment, showLoadingPayment} from "./frontend_script";

class DonatePage extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
		this.setDonate = this.setDonate.bind(this);
		this.showDonate = this.showDonate.bind(this);
		this.changeDonate = this.changeDonate.bind(this);
		this.enterDonate = this.enterDonate.bind(this);
		this.onClickwithDonation = this.onClickwithDonation.bind(this);

		this.state = {
			disability: 'decline',
			donation_count: 0,
			default_count: 10,
			add_other_show: false
		};
	}

	componentDidMount() {
		if (this.props.scroll_to_element === 'id_donate_div') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				containerId: "id_scrolling_div"
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}
	}

	onClickwithDonation() {
		if (this.state.disability !== 'donate' || !(this.state.donation_count > 0))
			showPopupWithGoBack('Please select Danation amount');
		else
			this.onClick();
	}

	onClick() {
		let booking_form_data = this.props.booking_form_data;
		let params = {};
		let t = this;

		params.action = 'api/booking/get_prices';
		params.signature_json = this.props.booking_form_data.signature_json;
		params.signature_png = this.props.booking_form_data.signature_png;
		params.vehicle_name = this.props.booking_form_data.vehicle_name;
		params.submit = this.state.disability;
		params.donation_count = this.state.donation_count;

		Object.keys(booking_form_data.driver_license_images).map((k) => {
			params['driver_license_images['+k+']'] = booking_form_data.driver_license_images[k];
		});

		Object.keys(booking_form_data.booking).map((k) => {
			params['booking['+k+']'] = booking_form_data.booking[k];
		});

		Object.keys(booking_form_data.additional_drivers).map((k) => {
			let driver_item = [];
			Object.keys(booking_form_data.additional_drivers[k]).map((kk) => {
				driver_item[kk] = booking_form_data.additional_drivers[k][kk];
			});
			params['booking['+k+'][]'] = driver_item;
		});

		if (this.props.booking_form_data.booking.hire == 'local') {
			params['booking[pickup_location]'] = this.props.booking_form_data.booking.pickuplocationid;
			params['booking[return_location]'] = this.props.booking_form_data.booking.dropofflocationid;
		}

		if (t.props.booking_form_data.booking.vehicle_payment === true) {
			//ga_client_id
			const gaCookie = document.cookie.split('; ').find(row => row.startsWith('_ga='));
			if (gaCookie) {
				const gaValue = gaCookie.split('=')[1];
				const decodedValue = decodeURIComponent(gaValue);
				params.ga_client_id = decodedValue.split('.').slice(2, 4).join('.'); // Extract client ID part
			}
			window.localStorage.removeItem('start_create_booking');
			window.localStorage.removeItem('end_create_booking');
			if (typeof window.stopBooking === 'function')
				window.stopBooking();
		}

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				if (t.props.booking_form_data.booking.vehicle_payment === true)
					showLoadingPayment();
				else
					showPreloader();
			},
			func_callback: function (resp) {
				if (t.props.booking_form_data.booking.vehicle_payment === true) { // way for not payment vehicle
					if (!resp.error) {
						if (resp && resp.data) {
							t.props.handleSetDonate(t.state.disability, t.state.donation_count);
						}
					} else {
						let message = '';

						if (resp.error == 'bad files') {
							t.props.handleSetSomeBlock('reset_photo_fields', true);
							t.props.handleSetSomeBlock('donate_show', false);
						} else {
							if (resp.error) {
								if (resp.fields !== undefined && resp.fields.length) {
									for (let i = 0; i < resp.fields.length; i++) {
										let field = resp.fields[i];

										if (field.name === 'additional_drivers_count') {
											message += ' Check additional driver\'s data';
										} else {
											message += (' ' + field.error);
										}
									}
									t.props.handleSetSomeBlock('donate_show', false);
								}

								if (message) {
									showPopupWithGoBack('Incorrect submitted form details. Please check, and try again. ' + message);
								} else {
									if (resp.error === 1) {
										if (resp.success_booking && resp.message === 'email has not been sent') {
											t.props.handleSetDonate(t.state.disability, t.state.donation_count);
											showPopupWithGoBack('Email has not been sent. Please try later or call to us.');
										}
										else {
											if (resp.message === 'Allowance not calculated') {
												showPopupWithGoBack('Distance cannot be calculated. Please try later or call to us.');
											} else {
												showPopupWithGoBack('Session invalid, please try again');
											}
										}
									}
								}
							}
						}
					}
					t.props.handleSetSomeBlock('scroll_to_element', '');
				}
				else { // usually way
					if (resp.success && resp.data) {
						t.props.handleSetDonate(t.state.disability, t.state.donation_count);
						t.props.handleSetShowData({ total_charges: resp.data.total_charges, total_all: resp.data.total_all, pre_authorization: resp.data.pre_authorization});

						t.props.handleSetSomeBlock('scroll_to_element', 'id_payment_div');
					} else {
						showPopupWithGoBack('Session invalid, please try again');
					}
				}
				if (t.props.booking_form_data.booking.vehicle_payment === true)
					hideLoadingPayment();
				else
					hidePreloader();
			},
			func_error: function (resp) {
				if (t.props.booking_form_data.booking.vehicle_payment === true)
					hideLoadingPayment();
				else
					hidePreloader();
				showPopupWithGoBack(resp.message);
			}
		});
	}

	setDonate(count) {
		if (this.state.disability === 'donate' && this.state.donation_count === count && this.state.add_other_show === false)
			this.setState({disability: 'decline', donation_count: 0, add_other_show: false});
		else
			this.setState({disability: 'donate', donation_count: count, add_other_show: false});
	}

	showDonate() {
		if (this.state.add_other_show === true)
			this.setState({disability: 'decline', add_other_show: false, donation_count: 0});
		else
			this.setState({disability: 'donate', add_other_show: true, donation_count: 10});
	}

	changeDonate(action) {
		this.setState((prevState, prevProps) => {
			if (action && prevState.donation_count < 99999){
				return {donation_count: ++prevState.donation_count};
			}
			else if (!action && prevState.donation_count > 1) {
				return {donation_count: --prevState.donation_count};
			}
		});
	}

	enterDonate(donation_input) {
		let donation = donation_input.replace("$", "");
		if (donation > 0 && donation < 100000)
			this.setState({disability: 'donate', donation_count: donation});
		else
			this.setState({disability: 'donate', donation_count: this.state.default_count});
	}

	render() {
		return (<>
			<RedirectOnlyHome />

			<div id={'id_donate_div'} className={'col'} style={{padding: "20px 30px", marginBottom: "25px"}}>
				<div className="row">
					<div className="col shadow-lg rounded" style={{paddingTop: "15px", marginBottom: "30px"}}>
						<div className="row justify-content-center justify-content-md-center">
							<div className="col-md-9">
								<div className="form-check-label text-center">
							 		<p><img src="../../wp-content/plugins/booking-form/images/AdventureOut_Logo.webp" alt="afford" className="aligncenter"/></p>
									<p>Go With The Gecko supports <a target="_blank" href="https://adventureoutltd.org/">ADventure Out</a>, a not for profit enterprise who<br/>
									do incredible work improving the lives of people living with disability.<br/>
									If you'd like to <a target="_blank" href="https://gowiththegecko.com.au/community-support/">join us</a> and contribute to this cause as part of your booking,<br/>
									please use the buttons below to contribute. Thank you!</p>
								</div>
							</div>
						</div>
						<div className="row justify-content-center justify-content-md-center mb-2">
							<div className="col-auto col-md-auto mb-2">
								<input type="button" className={'btn '+ ((this.state.disability === 'donate' && this.state.donation_count === 2 && this.state.add_other_show === false) ? 'btn-danger' : 'btn-success')} value="$2.00" onClick={() => this.setDonate(2)}/>
							</div>
							<div className="col-auto col-md-auto mb-2">
								<input type="button" className={'btn '+ ((this.state.disability === 'donate' && this.state.donation_count === 5 && this.state.add_other_show === false) ? 'btn-danger' : 'btn-success')} value="$5.00" onClick={() => this.setDonate(5)}/>
							</div>
							<div className="col-auto col-md-auto mb-2">
								<input type="button" className={'btn '+ ((this.state.disability === 'donate' && this.state.donation_count === 10 && this.state.add_other_show === false) ? 'btn-danger' : 'btn-success')} value="$10.00" onClick={() => this.setDonate(10)}/>
							</div>
							<div className="col-auto col-md-auto mb-2">
								<input type="button" className={'btn '+ ((this.state.disability === 'donate' && this.state.donation_count === 20 && this.state.add_other_show === false) ? 'btn-danger' : 'btn-success')} value="$20.00" onClick={() => this.setDonate(20)}/>
							</div>
							<div className="col-auto col-md-auto mb-2">
								<input type="button" className={'btn '+ ((this.state.disability === 'donate' && this.state.add_other_show === true) ? 'btn-danger' : 'btn-success')} value="Other" onClick={this.showDonate}/>
							</div>
						</div>
						{
							(this.state.add_other_show) &&
							(
								<div className="row justify-content-center justify-content-md-center mb-4">
									<div className="col-auto col-md-auto">
										<div id="donation_count_field" className="counter" data-min="1" data-max="100000" data-step="1" data-name="donation_count">
											<div className="btn decrementer"
												 style={{display: "inline-block", width: "60px", height: "35px", fontSize: "25px", textAlign: "center", verticalAlign: "middle", lineHeight: "20px", cursor: "pointer", userSelect: "none", backgroundColor: "#28A745", color: "#FFFFFF", border: "1px solid #28A745"}}
												 onClick={() => this.changeDonate(false)}>-
											</div>
											<input className="number-input number-input-wide" name="donation_count" min="1" max="100000" step="1" value={(this.state.donation_count > -1) ? '$'+this.state.donation_count : '$'+this.state.default_count} onChange={(ev) => this.enterDonate(ev.target.value)}/>
											<div className="btn incrementer"
												 style={{display: "inline-block", width: "60px", height: "35px", fontSize: "30px", textAlign: "center", verticalAlign: "middle", lineHeight: "20px", cursor: "pointer", userSelect: "none", backgroundColor: "#28A745", color: "#FFFFFF", border: "1px solid #28A745"}}
												 onClick={() => this.changeDonate(true)}>+
											</div>
										</div>
									</div>
								</div>
							)
						}
					</div>
				</div>
				<div className="row justify-content-center justify-content-md-center">
					<div className="col-auto col-md-auto mb-2">
						<input type="button" className="btn btn-secondary" value="Decline and Proceed" onClick={this.onClick}/>
					</div>
					<div className="col-auto col-md-auto mb-2">
						<input type="button" className="btn btn-success" value="Proceed with Donation" onClick={this.onClickwithDonation}/>
					</div>
				</div>
			</div>

		</>);
	}
}

export default DonatePage;
